import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "flex gap-2"
};
const _hoisted_2 = {
  class: "w-1/2"
};
const _hoisted_3 = {
  key: 0,
  class: "w-1/2"
};
const _hoisted_4 = {
  key: 1,
  class: "w-1/2"
};
const _hoisted_5 = {
  key: 2,
  class: "w-1/2"
};
const _hoisted_6 = {
  key: 0,
  class: "w-full"
};
const _hoisted_7 = {
  class: "w-full flex gap-2"
};
const _hoisted_8 = {
  key: 0,
  class: "w-3/12 pt-1"
};
const _hoisted_9 = {
  class: "w-full flex gap-2"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  key: 0,
  class: "w-3/12 pt-1"
};
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore.js';
import { useInvoiceState } from '@/modules/billing/review/editDraft/useInvoiceState';
import LlTextarea from '@/components/LlTextarea.vue';
import LlResizableTextarea from '@/components/LlResizableTextarea.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlTextField from '../../../../../components/LlTextField.vue';
import { computed, onMounted, reactive } from 'vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { useLineItemActions } from '@/modules/billing/review/editDraft/useLineItemsActions';
export default {
  __name: 'DescriptionPreviewModal',
  props: {
    lineItem: Object,
    disabled: Boolean
  },
  setup(__props) {
    const props = __props;
    const {
      permissions
    } = storeToRefs(useMeStore());
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const {
      onlyViewInvoice
    } = storeToRefs(useInvoiceEditorStore());
    const {
      constructDescription
    } = useLineItemActions();
    const invoiceState = useInvoiceState();
    const preview = reactive({
      includeCodes: false,
      includeInitials: false,
      includeMatterName: false,
      includeHours: false,
      matter: {}
    });
    onMounted(async () => {
      preview.lineItemOriginalDescription = JSON.parse(JSON.stringify(props.lineItem.description));
      if (props.lineItem.expenses) {
        preview.entityDescription = props.lineItem.expenses[0].description;
      } else if (props.lineItem.entries) {
        preview.entityDescription = props.lineItem.entries[0].description;
      } else if (props.lineItem.charges) {
        preview.entityDescription = props.lineItem.charges[0].description;
      }
      let invoiceFormatSettings = Object.keys(invoiceState.format).length > 0 ? invoiceState.format : invoiceState.client.invoice || companySettings?.invoice;
      preview.matter = getMatter;
      await setIncludeInitials(invoiceFormatSettings);
      await setIncludeCodes(invoiceFormatSettings);
      await setIncludeHours(invoiceFormatSettings);
      await setIncludeMatterName(invoiceFormatSettings);
    });
    const adjustments = computed(() => {
      return companySettings.value?.adjustments || false;
    });
    const includeCodesLabel = computed(() => {
      return props.lineItem.expenses ? 'Include Expense Code' : 'Include Codes';
    });

    // add computed property which calculates descreption to show in preview
    const descriptionPreview = computed(() => {
      return constructDescription(props.lineItem, preview);
    });
    const setIncludeInitials = async invoiceFormatSettings => {
      let initials = props.lineItem.account?.initials || props.lineItem.account?.name;
      preview.includeInitials = props.lineItem.expenses && invoiceFormatSettings.includeUserInExpenseDescription && props.lineItem.account && props.lineItem.description.indexOf(initials) > -1 || props.lineItem.entries && invoiceFormatSettings.includeUser && props.lineItem.description.indexOf(initials) > -1;
    };
    const setIncludeCodes = async invoiceFormatSettings => {
      let ledesEnabled = invoiceState.ledes && invoiceFormatSettings.includeCodes;
      let codesInLineItemDescription = false;
      if (props.lineItem.expenses) {
        let codeId = props.lineItem.expenses[0]?.codeId || props.lineItem.expenses[0]?.code?.id;
        codesInLineItemDescription = props.lineItem.description.indexOf(codeId) > -1;
      } else if (props.lineItem.entries) {
        codesInLineItemDescription = props.lineItem.description.indexOf(props.lineItem.entries[0]?.codes?.activity?.id) > -1 || props.lineItem.description.indexOf(props.lineItem.entries[0]?.codes?.task?.id) > -1;
      } else if (props.lineItem.charges) {
        codesInLineItemDescription = props.lineItem.charges[0].codes && props.lineItem.charges[0].codes.activity && props.lineItem.description.indexOf(props.lineItem.charges[0].codes.activity.id) > -1;
      }
      preview.includeCodes = ledesEnabled && codesInLineItemDescription;
    };
    const setIncludeHours = async invoiceFormatSettings => {
      if (props.lineItem.entries && props.lineItem.entries.length > 1 && invoiceFormatSettings.combineHours && props.lineItem.description.indexOf(props.lineItem.entries[0].hours) > -1) {
        preview.includeHours = true;
      }
    };
    const setIncludeMatterName = async invoiceFormatSettings => {
      preview.includeMatterName = invoiceFormatSettings.includeMatter && props.lineItem.description.indexOf(preview.matter?.name) > -1;
    };
    const removeEntry = entry => {
      props.lineItem.status = 'updated';
      let index = props.lineItem.entries.indexOf(entry);
      if (index > -1) {
        props.lineItem.entries.splice(index, 1);
      }
    };
    const showIncludeLedes = computed(() => {
      return invoiceState.ledes && (props.lineItem.expenses || props.lineItem.entries || props.lineItem.charges);
    });
    const disableIncludeLedes = computed(() => {
      if (props.lineItem.entries) {
        return props.lineItem.codes?.activity?.id === null && props.lineItem.codes?.task?.id === null;
      }
      // need to add logic for charges and expenses
      return false;
    });
    const showIncludeInitials = computed(() => {
      return props.lineItem.expenses || props.lineItem.entries;
    });
    const showIncludeHours = computed(() => {
      return props.lineItem.entries && props.lineItem.entries.length > 1;
    });
    const getMatter = computed(() => {
      if (invoiceState.matter?.id) {
        return invoiceState.matter;
      } else if (invoiceState.matters?.length > 1) {
        let matterId = props.lineItem.expenses ? props.lineItem.expenses[0]?.matter?.id : props.lineItem.entries ? props.lineItem.entries[0]?.matter?.id : props.lineItem.charges ? props.lineItem.charges[0]?.matter?.id : null;
        return invoiceState.matters.find(x => x.id === matterId);
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createVNode(LlTextarea, {
        label: "Line Item Description Preview",
        modelValue: descriptionPreview.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => descriptionPreview.value = $event),
        variant: "outlined",
        "hide-details": "true",
        readonly: true
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[5] || (_cache[5] = _createElementVNode("label", null, "Description Options", -1)), showIncludeLedes.value ? (_openBlock(), _createBlock(LlCheckbox, {
        key: 0,
        label: includeCodesLabel.value,
        modelValue: preview.includeCodes,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => preview.includeCodes = $event),
        disabled: __props.disabled || disableIncludeLedes.value
      }, null, 8, ["label", "modelValue", "disabled"])) : _createCommentVNode("", true), showIncludeInitials.value ? (_openBlock(), _createBlock(LlCheckbox, {
        key: 1,
        label: "Include Initials",
        modelValue: preview.includeInitials,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => preview.includeInitials = $event),
        disabled: __props.disabled
      }, null, 8, ["modelValue", "disabled"])) : _createCommentVNode("", true), _createVNode(LlCheckbox, {
        label: "Include Matter Name",
        modelValue: preview.includeMatterName,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => preview.includeMatterName = $event),
        disabled: __props.disabled
      }, null, 8, ["modelValue", "disabled"]), showIncludeHours.value ? (_openBlock(), _createBlock(LlCheckbox, {
        key: 2,
        label: "Include Hours",
        modelValue: preview.includeHours,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => preview.includeHours = $event),
        disabled: __props.disabled
      }, null, 8, ["modelValue", "disabled"])) : _createCommentVNode("", true)]), __props.lineItem.expenses ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.lineItem.expenses, expense => {
        return _openBlock(), _createBlock(LlResizableTextarea, {
          label: "Expense Description",
          modelValue: expense.description,
          "onUpdate:modelValue": $event => expense.description = $event,
          disabled: __props.disabled || _unref(onlyViewInvoice) || !_unref(permissions)?.billing?.edit
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]);
      }), 256))])) : _createCommentVNode("", true), __props.lineItem.charges && !__props.lineItem.entries ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.lineItem.charges, charge => {
        return _openBlock(), _createBlock(LlResizableTextarea, {
          label: "Fixed Fee Description",
          modelValue: charge.description,
          "onUpdate:modelValue": $event => charge.description = $event,
          disabled: __props.disabled || _unref(onlyViewInvoice) || !_unref(permissions)?.billing?.edit
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]);
      }), 256))])) : _createCommentVNode("", true), __props.lineItem.entries && __props.lineItem.entries.length === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.lineItem.entries, entry => {
        return _openBlock(), _createElementBlock("div", null, [_createVNode(LlResizableTextarea, {
          label: "Time Entry Description",
          modelValue: entry.description,
          "onUpdate:modelValue": $event => entry.description = $event,
          disabled: __props.disabled || _unref(onlyViewInvoice) || !_unref(permissions)?.billing?.edit
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]);
      }), 256))])) : _createCommentVNode("", true)]), __props.lineItem.entries && __props.lineItem.entries.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
        class: _normalizeClass(adjustments.value ? 'w-6/12' : 'w-8/12')
      }, "Description", 2), _createElementVNode("div", {
        class: _normalizeClass(adjustments.value ? 'w-3/12 pt-1' : 'w-4/12 pt-1')
      }, "Hours", 2), adjustments.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Write Downs")) : _createCommentVNode("", true)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.lineItem.entries, entry => {
        return _openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", {
          class: _normalizeClass(adjustments.value ? 'w-6/12' : 'w-8/12')
        }, [_createVNode(LlResizableTextarea, {
          modelValue: entry.description,
          "onUpdate:modelValue": $event => entry.description = $event,
          disabled: _unref(onlyViewInvoice) || !_unref(permissions)?.billing?.edit
        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])], 2), _createElementVNode("div", {
          class: _normalizeClass(adjustments.value ? 'w-3/12 pt-1' : 'w-4/12 pt-1')
        }, [_createVNode(LlTextField, {
          density: "compact",
          variant: "outlined",
          type: "number",
          step: entry.step,
          modelValue: entry.hours,
          "onUpdate:modelValue": $event => entry.hours = $event,
          disabled: _unref(onlyViewInvoice) || !_unref(permissions)?.billing?.edit,
          onChange: $event => _ctx.$emit('updateHours', entry),
          placeholder: "0"
        }, null, 8, ["step", "modelValue", "onUpdate:modelValue", "disabled", "onChange"]), _createElementVNode("a", {
          onClick: $event => removeEntry(entry)
        }, "Save for later", 8, _hoisted_10)], 2), adjustments.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(LlTextField, {
          density: "compact",
          variant: "outlined",
          step: entry.step,
          type: "number",
          modelValue: entry.writedown,
          "onUpdate:modelValue": $event => entry.writedown = $event,
          disabled: _unref(onlyViewInvoice) || !_unref(permissions)?.billing?.edit,
          onChange: $event => _ctx.$emit('updateHours', entry),
          placeholder: "0"
        }, null, 8, ["step", "modelValue", "onUpdate:modelValue", "disabled", "onChange"])])) : _createCommentVNode("", true)]);
      }), 256))])) : _createCommentVNode("", true)], 64);
    };
  }
};